// Components
import { Badge, Box, Flex, HStack, Progress, Text } from "@chakra-ui/react"
import { Profile, Tag } from "components"

// Config
import { Enums } from "config"

export default function Downline({ data, ...props }){

    const status = Enums.ActiveMonthStatus.data(data.active_month_status)

    return(
    <Box borderWidth={1} borderTopWidth={0} borderRadius={8} borderStyle="dashed">
        
        <Box w="100%" backgroundColor="rgba(0,0,0,0.3)" py={2} px={4} textAlign="center">
            <Flex justifyContent="space-between">
                <Text children={data.career?.title} fontSize="xs" fontWeight="bold" />
                <Tag size="sm" colorScheme={status.colorScheme} children={data.active_month_status_label} />
            </Flex>
        </Box>

        <Box p={4}>
            <Profile name={data.name} />

            <Flex justifyContent="space-between" mt={2}>
                <Text color="GrayText" fontSize="0.7rem">Pontos aplicáveis: <Text color="InfoText" fontWeight="bold" children={data.points.qualified / 100} /></Text>
                <Text color="GrayText" fontSize="0.7rem">VME: <Text color="InfoText" fontWeight="bold" children={data.vme.limit / 100} /></Text>
            </Flex>
            <Progress value={data.vme.percentage} size="xs" colorScheme="orange" mt={1} borderRadius={8} />
        </Box>
    </Box>
    )
}